import { render, staticRenderFns } from "./Wish.vue?vue&type=template&id=d17b6da4&scoped=true"
import script from "./Wish.vue?vue&type=script&lang=js"
export * from "./Wish.vue?vue&type=script&lang=js"
import style0 from "./Wish.vue?vue&type=style&index=0&id=d17b6da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17b6da4",
  null
  
)

export default component.exports